import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_DATA, CLIENT_DATA } from '@frontend/util-api-data';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DownloadDocumentService {
  private http = inject(HttpClient);

  private apiData = inject(API_DATA);
  private client = inject(CLIENT_DATA).name;

  getDownloadData(categoryId: number, documentId: number): Observable<any> {
    const url = `${this.apiData.apiURL}api/${this.client}/downloadcenter/files/category/${categoryId}/document/${documentId}`;

    return this.http.get(url).pipe(
      catchError((error) => {
        console.error('Error fetching document:', error);
        return throwError(() => new Error('Failed to load document'));
      })
    );
  }
}
